import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import consola from 'consola';
import userLogin from '@/graphql/user/userLogin.gql';
import autologinMutation from '@/graphql/user/authentication/autologin.gql';
import logoutUserMutation from '@/graphql/user/authentication/logoutUser.gql';
import userQuery from '~/graphql/user/me.gql';
import profileQuery from '~/graphql/user/profile.gql';
import ordersQuery from '~/graphql/user/orders.gql';
import orderQuery from '~/graphql/user/order.gql';
import addressesQuery from '~/graphql/user/address/addresses.gql';
import createUserAddressQuery from '~/graphql/user/address/createUserAddress.gql';
import updateUserAddressMutation from '~/graphql/user/address/updateUserAddress.gql';
import updateUserInformationMutation from '~/graphql/user/updateUserInformation.gql';
import updateUserPasswordMutation from '~/graphql/user/updateUserPassword.gql';
import discountsQuery from '~/graphql/user/discounts.gql';
import updateUserOptinMutation from '~/graphql/user/updateUserOptin.gql';
import deleteUserAddressQuery from '~/graphql/user/address/deleteUserAddress.gql';
import subscribeToNewsletterMutation from '~/graphql/user/newsletter.gql';
import updateUserTokenMutation from '~/graphql/user/authentication/updateUserToken.gql';
import refreshTokenMutation from '~/graphql/user/authentication/refreshToken.gql';
import { isValidToken } from '~/helpers/connection-helper';
import { logError } from '@/helpers/log-helper';

function loginUser(_x, _x2, _x3) {
  return _loginUser.apply(this, arguments);
}

function _loginUser() {
  _loginUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apolloClient, email, password) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return apolloClient.mutate({
              errorPolicy: 'all',
              mutation: userLogin,
              variables: {
                email: email,
                password: password
              }
            });

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loginUser.apply(this, arguments);
}

function autologin(_x4, _x5) {
  return _autologin.apply(this, arguments);
}

function _autologin() {
  _autologin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(apolloClient, token) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return apolloClient.mutate({
              mutation: autologinMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }
            });

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _autologin.apply(this, arguments);
}

function logoutUser(_x6) {
  return _logoutUser.apply(this, arguments);
}

function _logoutUser() {
  _logoutUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: logoutUserMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            logError({
              msg: "logoutUser ".concat(_context3.t0),
              context: this
            });

          case 10:
            return _context3.abrupt("return", null);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 7]]);
  }));
  return _logoutUser.apply(this, arguments);
}

function fetchUser(_x7) {
  return _fetchUser.apply(this, arguments);
}

function _fetchUser() {
  _fetchUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(context) {
    var _yield$context$app$ap, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!isValidToken()) {
              _context4.next = 6;
              break;
            }

            _context4.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: userQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 3:
            _yield$context$app$ap = _context4.sent;
            data = _yield$context$app$ap.data;
            return _context4.abrupt("return", data && data.user);

          case 6:
            return _context4.abrupt("return", null);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchUser.apply(this, arguments);
}

function fetchUserProfile(_x8) {
  return _fetchUserProfile.apply(this, arguments);
}

function _fetchUserProfile() {
  _fetchUserProfile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(context) {
    var _yield$context$app$ap2, data;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!isValidToken()) {
              _context5.next = 6;
              break;
            }

            _context5.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: profileQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 3:
            _yield$context$app$ap2 = _context5.sent;
            data = _yield$context$app$ap2.data;
            return _context5.abrupt("return", data && data.user);

          case 6:
            return _context5.abrupt("return", null);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchUserProfile.apply(this, arguments);
}

function fetchUserOrders(_x9, _x10, _x11) {
  return _fetchUserOrders.apply(this, arguments);
}

function _fetchUserOrders() {
  _fetchUserOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(context, limit, manageOrdersErrors) {
    var _yield$context$app$ap3, data, errors;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!isValidToken()) {
              _context6.next = 8;
              break;
            }

            _context6.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'no-cache',
              errorPolicy: manageOrdersErrors ? 'all' : 'none',
              query: ordersQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                limit: limit,
                mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
              }
            });

          case 3:
            _yield$context$app$ap3 = _context6.sent;
            data = _yield$context$app$ap3.data;
            errors = _yield$context$app$ap3.errors;

            if (manageOrdersErrors && errors) {
              consola.error(errors);
            }

            return _context6.abrupt("return", data && data.orders);

          case 8:
            return _context6.abrupt("return", null);

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchUserOrders.apply(this, arguments);
}

function fetchUserOrder(_x12, _x13) {
  return _fetchUserOrder.apply(this, arguments);
}

function _fetchUserOrder() {
  _fetchUserOrder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(context, reference) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!isValidToken()) {
              _context7.next = 6;
              break;
            }

            locale = context.state.i18n.currentLocale.iso;
            _context7.next = 4;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'no-cache',
              query: orderQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                reference: reference,
                locale: locale,
                mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
              }
            });

          case 4:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);

          case 6:
            return _context7.abrupt("return", null);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _fetchUserOrder.apply(this, arguments);
}

function fetchUserAddresses(_x14) {
  return _fetchUserAddresses.apply(this, arguments);
}

function _fetchUserAddresses() {
  _fetchUserAddresses = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!isValidToken()) {
              _context8.next = 5;
              break;
            }

            _context8.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: addressesQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);

          case 5:
            return _context8.abrupt("return", null);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchUserAddresses.apply(this, arguments);
}

function deleteUserAddress(_x15, _x16, _x17, _x18) {
  return _deleteUserAddress.apply(this, arguments);
}

function _deleteUserAddress() {
  _deleteUserAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(context, addressId, addressType, addressAlias) {
    var response;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!isValidToken()) {
              _context9.next = 5;
              break;
            }

            _context9.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: deleteUserAddressQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                addressId: addressId,
                addressType: addressType,
                addressAlias: addressAlias
              }
            });

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response.data);

          case 5:
            return _context9.abrupt("return", null);

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _deleteUserAddress.apply(this, arguments);
}

function createUserAddress(_x19, _x20) {
  return _createUserAddress.apply(this, arguments);
}

function _createUserAddress() {
  _createUserAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(context, address) {
    var response;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!isValidToken()) {
              _context10.next = 5;
              break;
            }

            _context10.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: createUserAddressQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                address: address
              }
            });

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response.data);

          case 5:
            return _context10.abrupt("return", null);

          case 6:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _createUserAddress.apply(this, arguments);
}

function updateUserAddress(_x21, _x22, _x23) {
  return _updateUserAddress.apply(this, arguments);
}

function _updateUserAddress() {
  _updateUserAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(context, addressId, address) {
    var response;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!isValidToken()) {
              _context11.next = 5;
              break;
            }

            _context11.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserAddressMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                addressId: addressId,
                address: address
              }
            });

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response.data);

          case 5:
            return _context11.abrupt("return", null);

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _updateUserAddress.apply(this, arguments);
}

function updateUserInformation(_x24, _x25) {
  return _updateUserInformation.apply(this, arguments);
}

function _updateUserInformation() {
  _updateUserInformation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(context, user) {
    var response;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!isValidToken()) {
              _context12.next = 5;
              break;
            }

            _context12.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserInformationMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                user: user
              }
            });

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response.data);

          case 5:
            return _context12.abrupt("return", null);

          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _updateUserInformation.apply(this, arguments);
}

function updateUserPassword(_x26, _x27, _x28) {
  return _updateUserPassword.apply(this, arguments);
}

function _updateUserPassword() {
  _updateUserPassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(context, oldPassword, newPassword) {
    var response;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (!isValidToken()) {
              _context13.next = 5;
              break;
            }

            _context13.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserPasswordMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                oldPassword: oldPassword,
                newPassword: newPassword
              }
            });

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
            return _context13.abrupt("return", null);

          case 6:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _updateUserPassword.apply(this, arguments);
}

function fetchDiscounts(_x29) {
  return _fetchDiscounts.apply(this, arguments);
}

function _fetchDiscounts() {
  _fetchDiscounts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(context) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!isValidToken()) {
              _context14.next = 6;
              break;
            }

            locale = context.state.i18n.currentLocale.iso;
            _context14.next = 4;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: discountsQuery,
              variables: {
                locale: locale
              },
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 4:
            response = _context14.sent;
            return _context14.abrupt("return", response.data);

          case 6:
            return _context14.abrupt("return", null);

          case 7:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _fetchDiscounts.apply(this, arguments);
}

function updateUserOptin(_x30, _x31, _x32) {
  return _updateUserOptin.apply(this, arguments);
}

function _updateUserOptin() {
  _updateUserOptin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(context, input, addressId) {
    var response;
    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (!isValidToken()) {
              _context15.next = 5;
              break;
            }

            _context15.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserOptinMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                input: input,
                addressId: addressId
              }
            });

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response.data);

          case 5:
            return _context15.abrupt("return", null);

          case 6:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _updateUserOptin.apply(this, arguments);
}

function subscribeToNewsletter(_x33, _x34, _x35) {
  return _subscribeToNewsletter.apply(this, arguments);
}

function _subscribeToNewsletter() {
  _subscribeToNewsletter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(context, email, optIn) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _context16.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: subscribeToNewsletterMutation,
              variables: {
                email: email,
                optIn: optIn,
                locale: locale
              }
            });

          case 3:
            response = _context16.sent;
            return _context16.abrupt("return", response.data);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _subscribeToNewsletter.apply(this, arguments);
}

function updateUserToken(_x36) {
  return _updateUserToken.apply(this, arguments);
}

function _updateUserToken() {
  _updateUserToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            if (!isValidToken()) {
              _context17.next = 5;
              break;
            }

            _context17.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserTokenMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 3:
            response = _context17.sent;
            return _context17.abrupt("return", response.data);

          case 5:
            return _context17.abrupt("return", null);

          case 6:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _updateUserToken.apply(this, arguments);
}

function refreshToken(_x37) {
  return _refreshToken.apply(this, arguments);
}

function _refreshToken() {
  _refreshToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: refreshTokenMutation,
              context: {}
            });

          case 2:
            response = _context18.sent;
            return _context18.abrupt("return", response.data);

          case 4:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _refreshToken.apply(this, arguments);
}

export { createUserAddress, deleteUserAddress, fetchDiscounts, fetchUser, fetchUserAddresses, fetchUserOrder, fetchUserOrders, fetchUserProfile, subscribeToNewsletter, loginUser, autologin, logoutUser, updateUserAddress, updateUserInformation, updateUserOptin, updateUserPassword, updateUserToken, refreshToken };